import { type PropsWithChildren, useEffect } from "react";
import { createPortal } from "react-dom";
import CrossIcon from "@/assets/icons/cross.svg?react";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

type ModalProps = {
  className?: string;
  isOpen: boolean;
  onClose: () => void;
  status: "error";
};
export default function Notification({ className, onClose, isOpen, children, status }: PropsWithChildren<ModalProps>) {
  const root = document.getElementById("root");

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 4000);

      // Cleanup the timer when the component is unmounted or if isOpen changes
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen || !root) {
    return null;
  }

  return createPortal(
    <>
      <div
        className={cn(
          "drop-schedule absolute right-2 top-2 z-30 mb-2 flex min-w-[360px] justify-between rounded p-4",
          className,
          status === "error" && "bg-error-100"
        )}
      >
        <Typography className="text-error-500" weight="medium" variant="text-small">
          {children}
        </Typography>
        <CrossIcon className="cursor-pointer text-error-500" onClick={onClose} />
      </div>
    </>,
    root
  );
}
